var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1000002515(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 15,
    fill: "#F2F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 26.75V24.25H36.75V21.75C36.748 21.0876 36.484 20.4528 36.0156 19.9844C35.5472 19.516 34.9124 19.252 34.25 19.25H31.75V16.75H29.25V19.25H26.75V16.75H24.25V19.25H21.75C21.0876 19.252 20.4528 19.516 19.9844 19.9844C19.516 20.4528 19.252 21.0876 19.25 21.75V24.25H16.75V26.75H19.25V29.25H16.75V31.75H19.25V34.25C19.252 34.9124 19.516 35.5472 19.9844 36.0156C20.4528 36.484 21.0876 36.748 21.75 36.75H24.25V39.25H26.75V36.75H29.25V39.25H31.75V36.75H34.25C34.9124 36.748 35.5472 36.484 36.0156 36.0156C36.484 35.5472 36.748 34.9124 36.75 34.25V31.75H39.25V29.25H36.75V26.75H39.25ZM34.25 34.25H21.75V21.75H34.25V34.25Z",
    fill: "#002A3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2012 23H25.5199L23.0074 33H24.2912L24.8712 30.6562H27.7662L28.3312 33H29.6587L27.2012 23ZM25.0399 29.655L26.3124 24.1875H26.3699L27.5987 29.655H25.0399ZM30.8049 23H32.0549V33H30.8049V23Z",
    fill: "#002A3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002515);
export default __webpack_public_path__ + "static/media/Group 1000002515.5689f05507f9881cd46df8fa85fb6661.svg";
export { ForwardRef as ReactComponent };